export const TABLE_COLUMNS = {
  MATERIAL: 'id',
  MAPE: 'porc_mape',
  BIAS: 'porc_bias',
  VAR_COSTO: 'por_cambio_costo',
  AGOTADOS: 'porc_disponibilidad',
  DESCRIPCION: 'texto',
  CATEGORY: 'leadtime',
  PED_L3M: 'demanda',
  PRESUPUESTO: 'presupuesto',
  CATEGORIA: 'categoria',
  MARCA: 'marca',
  FAMILIA: 'familia',
  CLASIFICACION: 'clasificacion',
  BASELINE: 'baseline',
  DELTA: 'category',
  EVENTOS: 'eventos',
  COMPRABLE: 'estado',
  TIPO: 'obligatorio'
};

export const MATERIAL_STATES = {
  FINALIZADO: 'Finalizado',
  POR_REVISAR: 'Por revisar',
  PENDIENTE: 'Pendiente',
  RETORNADO: 'Retornado'
};

export const TABLE_CONFIG = {
  PAGE_SIZES: [20, 50, 100],
  DEFAULT_PAGE_SIZE: 20,
  MAX_BODY_HEIGHT: '500px'
};

export const EXCEL_CONFIG = {
  SHEET_NAME: 'Datos Consolidados',
  HEADERS: ['Material', 'Nombre', 'Categoria', 'Subcategoria', 'Familia', 'Marca', 'Modelo', 'Variable'],
  VARIABLES: {
    AJUSTE_DEMANDA: 'Ajuste Demanda',
    BASELINE: 'Baseline',
    CATEGORY: 'Category',
    GERENTE: 'Gerente',
    SINCRONIZACION: 'Sincronizacion',
    JUNTA: 'Junta',
    DEMANDA: 'Demanda'
  },
  COLORS: {
    HEADER: 'FF0078D4',
    ALTERNATE_ROW: 'FFE6F3FF',
    WHITE: 'FFFFFFFF',
    BORDER: 'FF666666'
  }
};
